"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _underscore = require("../utils/underscore");

var _UITextInput = _interopRequireDefault(require("../input/UITextInput"));

var _UIInputIconWrapper = _interopRequireDefault(require("../input/internal/UIInputIconWrapper"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _AbstractCalendar = _interopRequireDefault(require("./internal/AbstractCalendar"));

var _FieldsetContext = require("../context/FieldsetContext");

var _SimpleDate = require("../core/SimpleDate");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _CalendarPagePopover = _interopRequireDefault(require("./internal/CalendarPagePopover"));

var _UsesToday = _interopRequireDefault(require("./internal/UsesToday"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _DomEvents = require("../utils/DomEvents");

var _SimpleDateTypes = require("../types/SimpleDateTypes");

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _decorators = require("../utils/propTypes/decorators");

var _Dom = require("../utils/Dom");

var _Locale = require("../utils/Locale");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _deprecated = _interopRequireDefault(require("../utils/propTypes/deprecated"));

var isValidValue = function isValidValue(value, minValue, maxValue) {
  if (value == null) return true;
  if (!(0, _SimpleDate.isValid)(value)) return false;
  return (0, _SimpleDate.isDateInRange)(value, minValue, maxValue);
};

var UIDateInputCore =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIDateInputCore, _PureComponent);

  function UIDateInputCore(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIDateInputCore);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIDateInputCore).call(this, props));

    _this.handleFocus = function (evt) {
      var _this$props = _this.props,
          inputRef = _this$props.inputRef,
          onFocus = _this$props.onFocus;
      inputRef.current.select();
      if (onFocus) onFocus(evt);
    };

    _this.handleFocusLeave = function () {
      var onOpenChange = _this.props.onOpenChange;
      onOpenChange((0, _SyntheticEvent.default)(false));
    };

    _this.open = function () {
      var onOpenChange = _this.props.onOpenChange;
      onOpenChange((0, _SyntheticEvent.default)(true));
    };

    _this._calendarId = (0, _underscore.uniqueId)('dateinput-calendar-');
    _this._popoverId = (0, _underscore.uniqueId)('dateinput-popover-');
    return _this;
  }

  (0, _createClass2.default)(UIDateInputCore, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          autoFocus = _this$props2.autoFocus,
          calendarPage = _this$props2.calendarPage,
          className = _this$props2.className,
          clearLabel = _this$props2.clearLabel,
          disabled = _this$props2.disabled,
          disabledValues = _this$props2.disabledValues,
          error = _this$props2.error,
          focusedValue = _this$props2.focusedValue,
          format = _this$props2.format,
          iconSize = _this$props2.iconSize,
          id = _this$props2.id,
          Input = _this$props2.Input,
          inputRef = _this$props2.inputRef,
          inputWidth = _this$props2.inputWidth,
          locale = _this$props2.locale,
          min = _this$props2.min,
          minValue = _this$props2.minValue,
          max = _this$props2.max,
          maxValue = _this$props2.maxValue,
          maxValidationMessage = _this$props2.maxValidationMessage,
          maxValueValidationMessage = _this$props2.maxValueValidationMessage,
          minValidationMessage = _this$props2.minValidationMessage,
          minValueValidationMessage = _this$props2.minValueValidationMessage,
          name = _this$props2.name,
          onCalendarPageChange = _this$props2.onCalendarPageChange,
          onChange = _this$props2.onChange,
          onOpenChange = _this$props2.onOpenChange,
          open = _this$props2.open,
          readOnly = _this$props2.readOnly,
          today = _this$props2.today,
          todayLabel = _this$props2.todayLabel,
          use = _this$props2.use,
          value = _this$props2.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["autoFocus", "calendarPage", "className", "clearLabel", "disabled", "disabledValues", "error", "focusedValue", "format", "iconSize", "id", "Input", "inputRef", "inputWidth", "locale", "min", "minValue", "max", "maxValue", "maxValidationMessage", "maxValueValidationMessage", "minValidationMessage", "minValueValidationMessage", "name", "onCalendarPageChange", "onChange", "onOpenChange", "open", "readOnly", "today", "todayLabel", "use", "value"]);
      return _react.default.createElement(_FieldsetContext.FieldsetContextConsumer, null, function (fieldsetContext) {
        var computedDisabled = disabled || fieldsetContext.disabled;
        return _react.default.createElement(_AbstractCalendar.default, _this2.props, function (_ref) {
          var onInputChange = _ref.onInputChange,
              onKeyDown = _ref.onKeyDown,
              onKeyUp = _ref.onKeyUp,
              onBlur = _ref.onBlur,
              inputValue = _ref.inputValue;
          return _react.default.createElement(_CalendarPagePopover.default, {
            calendarId: _this2._calendarId,
            calendarPage: calendarPage,
            clearLabel: clearLabel,
            disabledValues: disabledValues,
            focusedValue: focusedValue,
            id: _this2._popoverId,
            locale: locale,
            max: max || maxValue,
            min: min || minValue,
            maxValidationMessage: maxValidationMessage || maxValueValidationMessage,
            minValidationMessage: minValidationMessage || minValueValidationMessage,
            onCalendarPageChange: onCalendarPageChange,
            onChange: onChange,
            onFocusLeave: _this2.handleFocusLeave,
            onMouseDown: _DomEvents.preventDefaultHandler
            /* keep input focused */
            ,
            onOpenChange: onOpenChange,
            open: open && !computedDisabled && !readOnly,
            today: today,
            todayLabel: todayLabel,
            value: value
          }, _react.default.createElement(_UIInputIconWrapper.default, (0, _extends2.default)({}, rest, {
            className: className,
            disabled: computedDisabled,
            iconName: "date",
            onFocus: _this2.handleFocus,
            size: iconSize || fieldsetContext.size
          }), _react.default.createElement(Input, {
            autoComplete: "off",
            autoFocus: autoFocus,
            className: (0, _Dom.listAttrIncludes)(className, 'private-form__control--inline') ? 'private-form__control--inline' : undefined,
            "data-format": (0, _Locale.getLocalizedDateFormat)(format, locale),
            disabled: computedDisabled,
            error: error || !isValidValue(value, minValue, maxValue),
            id: id,
            inputRef: inputRef,
            name: name,
            onBlur: onBlur,
            onChange: onInputChange,
            onClick: _this2.open,
            onFocus: _this2.open,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            placeholder: (0, _Locale.getDatePlaceholder)(format, locale),
            readOnly: readOnly,
            use: use,
            value: inputValue,
            width: inputWidth
          })));
        });
      });
    }
  }]);
  return UIDateInputCore;
}(_react.PureComponent);

var deprecatedMinMaxMessage = function deprecatedMinMaxMessage(propName) {
  var newPropName = propName.replace('Value', '');
  return {
    message: "UIDateInput: The `" + propName + "` prop is deprecated. Use `" + newPropName + "` instead.",
    key: 'UIDateInput-old-minmax'
  };
};

UIDateInputCore.propTypes = {
  autoFocus: _propTypes.default.bool,
  calendarPage: _propTypes.default.shape({
    year: _propTypes.default.number.isRequired,
    month: _propTypes.default.number.isRequired
  }),
  clearLabel: (0, _createLazyPropType.default)(_propTypes.default.string),
  disabled: _propTypes.default.bool,
  disabledValues: _propTypes.default.arrayOf(_SimpleDateTypes.SimpleDateType),
  error: _propTypes.default.bool,
  focusedValue: (0, _decorators.hidden)(_SimpleDateTypes.SimpleDateType),
  format: _propTypes.default.oneOf(['L', 'YYYY-MM-DD']).isRequired,
  iconSize: (0, _decorators.hidden)(_propTypes.default.number),
  id: _propTypes.default.string,
  Input: (0, _decorators.hidden)(_component.default.isRequired),
  inputRef: _refObject.default.isRequired,
  inputWidth: (0, _decorators.hidden)(_propTypes.default.number),
  locale: (0, _decorators.hidden)(_propTypes.default.string),
  max: _SimpleDateTypes.SimpleDateType,
  maxValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
  maxValue: (0, _deprecated.default)(_SimpleDateTypes.SimpleDateType, deprecatedMinMaxMessage),
  maxValueValidationMessage: (0, _deprecated.default)((0, _createLazyPropType.default)(_propTypes.default.string), deprecatedMinMaxMessage),
  min: _SimpleDateTypes.SimpleDateType,
  minValue: (0, _deprecated.default)(_SimpleDateTypes.SimpleDateType, deprecatedMinMaxMessage),
  minValidationMessage: (0, _createLazyPropType.default)(_propTypes.default.string),
  minValueValidationMessage: (0, _deprecated.default)((0, _createLazyPropType.default)(_propTypes.default.string), deprecatedMinMaxMessage),
  name: _propTypes.default.string,
  onCalendarPageChange: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  onOpenChange: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired,
  readOnly: _propTypes.default.bool,
  today: _SimpleDateTypes.SimpleDateType.isRequired,
  todayLabel: (0, _createLazyPropType.default)(_propTypes.default.string),
  use: _UITextInput.default.propTypes.use,
  value: _SimpleDateTypes.SimpleDateType
};
UIDateInputCore.defaultProps = {
  clearLabel: function clearLabel() {
    return _I18n.default.text('ui.datePicker.clear');
  },
  format: 'L',
  Input: _UITextInput.default,
  maxValidationMessage: function maxValidationMessage() {
    return _I18n.default.text('ui.datePicker.dateAboveMax');
  },
  minValidationMessage: function minValidationMessage() {
    return _I18n.default.text('ui.datePicker.dateBelowMin');
  },
  open: false,
  todayLabel: function todayLabel() {
    return _I18n.default.text('ui.datePicker.today');
  }
};
UIDateInputCore.displayName = 'UIDateInput';

var _default = (0, _ShareInput.default)((0, _Controllable.default)((0, _UsesToday.default)(UIDateInputCore), ['calendarPage', 'focusedValue', 'open', 'value']));

exports.default = _default;
module.exports = exports.default;